import { render, staticRenderFns } from "./DuplicateItems.vue?vue&type=template&id=7afe1141&"
import script from "./DuplicateItems.vue?vue&type=script&lang=js&"
export * from "./DuplicateItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports